// src/pages/user/ChangePassword.js
import React, { useState } from 'react';
import { userAuthAPI } from '../../services/api';
import './UserSettings.css';

const ChangePassword = ({ onClose }) => {
  const [form, setForm]         = useState({ current: '', newPwd: '', confirm: '' });
  const [show, setShow]         = useState({ current: false, newPwd: false });
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const [success, setSuccess]   = useState('');

  const handle = (field) => (e) => {
    setForm(p => ({ ...p, [field]: e.target.value }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    if (form.newPwd !== form.confirm)    { setError('New passwords do not match.'); return; }
    if (form.newPwd.length < 8)          { setError('New password must be at least 8 characters.'); return; }
    setLoading(true);
    try {
      await userAuthAPI.changePassword(form.current, form.newPwd);
      setSuccess('Password changed successfully!');
      setForm({ current: '', newPwd: '', confirm: '' });
    } catch (err) {
      setError(err.message || 'Failed to change password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="settings-page">
      <div className="settings-card">

        {/* Header */}
        <div className="settings-card-header">
          <div className="settings-title">
            <div className="settings-title-icon">
              <i className="bi bi-lock-fill"></i>
            </div>
            <div>
              <h2>Change Password</h2>
              <p>Update your account password</p>
            </div>
          </div>
          {onClose && (
            <button className="settings-close-btn" onClick={onClose}>
              <i className="bi bi-x-lg"></i>
            </button>
          )}
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="settings-form">
          {error   && <div className="settings-alert settings-alert-error"><i className="bi bi-exclamation-circle-fill"></i>{error}</div>}
          {success && <div className="settings-alert settings-alert-success"><i className="bi bi-check-circle-fill"></i>{success}</div>}

          <div className="settings-field">
            <label className="settings-label"><i className="bi bi-lock"></i> Current Password</label>
            <div className="settings-input-wrapper">
              <input
                type={show.current ? 'text' : 'password'}
                className="settings-input"
                placeholder="Enter current password"
                value={form.current}
                onChange={handle('current')}
                required disabled={loading}
              />
              <button type="button" className="settings-eye-btn" onClick={() => setShow(p => ({ ...p, current: !p.current }))}>
                <i className={`bi ${show.current ? 'bi-eye-slash' : 'bi-eye'}`}></i>
              </button>
            </div>
          </div>

          <div className="settings-field">
            <label className="settings-label"><i className="bi bi-lock-fill"></i> New Password</label>
            <div className="settings-input-wrapper">
              <input
                type={show.newPwd ? 'text' : 'password'}
                className="settings-input"
                placeholder="Min 8 characters"
                value={form.newPwd}
                onChange={handle('newPwd')}
                required disabled={loading}
              />
              <button type="button" className="settings-eye-btn" onClick={() => setShow(p => ({ ...p, newPwd: !p.newPwd }))}>
                <i className={`bi ${show.newPwd ? 'bi-eye-slash' : 'bi-eye'}`}></i>
              </button>
            </div>
          </div>

          <div className="settings-field">
            <label className="settings-label"><i className="bi bi-lock-fill"></i> Confirm New Password</label>
            <div className="settings-input-wrapper">
              <input
                type={show.newPwd ? 'text' : 'password'}
                className="settings-input"
                placeholder="Re-enter new password"
                value={form.confirm}
                onChange={handle('confirm')}
                required disabled={loading}
              />
            </div>
          </div>

          <button type="submit" className="settings-submit-btn" disabled={loading}>
            {loading
              ? <><span className="settings-spinner"></span><span>Updating...</span></>
              : <><i className="bi bi-check-circle"></i><span>Update Password</span></>
            }
          </button>
        </form>

      </div>
    </div>
  );
};

export default ChangePassword;
